import React from 'react';

const Permissions: React.FC<React.PropsWithChildren> = () => (
  <path d="M8 4.5H21V6H8V4.5ZM3.5 5L4 5.5L5.5 4L6 4.5L4 6.5L3 5.5L3.5 5ZM3.5 12L4 12.5L5.5 11L6 11.5L4 13.5L3 12.5L3.5 12ZM3.5 19L4 19.5L5.5 18L6 18.5L4 20.5L3 19.5L3.5 19ZM8 11.5H21V13H8V11.5ZM8 18.5H21V20H8V18.5Z" />
);

export default Permissions;
